var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_222",
    "data-name": "Group 222",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.738,
    height: 43.032,
    viewBox: "0 0 24.738 43.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M16.8,25.309c1.744-3.148,5.1-5.005,7.044-7.791,2.061-2.922.906-8.38-4.937-8.38-3.828,0-5.707,2.9-6.5,5.3L6.54,11.969A12.818,12.818,0,0,1,18.884,3c5.322,0,8.969,2.423,10.826,5.458,1.585,2.6,2.514,7.474.068,11.1-2.718,4.009-5.322,5.232-6.727,7.814-.566,1.042-.793,1.721-.793,5.073H15.713C15.69,30.677,15.418,27.8,16.8,25.309ZM23.436,41.5a4.53,4.53,0,1,1-4.53-4.53A4.543,4.543,0,0,1,23.436,41.5Z",
    transform: "translate(-6.54 -3)",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueIcon);
export default __webpack_public_path__ + "static/media/que_icon.a846e76e7b7e519d5d4b2069c5d99474.svg";
export { ForwardRef as ReactComponent };